import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../Structure/components/Head/Head';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../Shared/components/Alerts/AlertsConteiner';
import {browserHistory} from 'react-router';
import {getAnimalsProtectora, loadInfoProtectoraDetail} from "../../AnimalList/actions/actionsAnimalList";
import {
    PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID,
    PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO,
    PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN,
    PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL
} from "../../../App/RouterAdopta";
import {checkIsLogin} from "../actions/actionsAdmin";
// import { Line } from 'react-chartjs-2';
// var LineChart = require("react-chartjs").Line;
import GraficoLineas from "../../Shared/components/Charts/GraficoLineas";
import ChartNumberImpresiones from "../../Shared/components/Charts/ChartNumberImpresiones";
import ChartNumberClics from "../../Shared/components/Charts/ChartNumberClics";
import ChartNumberCTR from "../../Shared/components/Charts/ChartNumberCTR";
//https://github.com/reactchartjs/react-chartjs-2/blob/v2.4.0/
const dataProtectora = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'Impresiones',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: []
        },
        {
            label: 'Clics',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(31,120,203,0.4)',
            borderColor: 'rgba(31,120,203,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(31,120,203,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(31,120,203,1)',
            pointHoverBorderColor: 'rgba(31,120,203,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: []
        }
    ]
};

const dataAnimales = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'Impresiones',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: []
        },
        {
            label: 'Clics',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(31,120,203,0.4)',
            borderColor: 'rgba(31,120,203,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(31,120,203,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(31,120,203,1)',
            pointHoverBorderColor: 'rgba(31,120,203,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: []
        }
    ]
};

class AdminHallPage extends Component {

    constructor(props) {
        super(props);

        this.animalsControl = "animalsProtectora"
        this.props.isLogin();
    }

    goPerfil() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_PERFIL);
    }

    goAdminAnimals() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID + this.props.access.id);
    }

    goinsertAnimal() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO);
    }


    render() {
        const infoProtectora = this.props.animalDetailProtectora.infoProtectoraDetail;
        let showMetricas = false;
        let objMetricasTotales = {
            clics: {
                perfil: 0
            },
            impresiones: {
                perfil: 0
            }
        }

        try {
            if (this.props.animals && this.props.animals.length) {
                const infoAnimales = this.props.animals;
                let metricasTotalesAnimales = infoAnimales.map((animal) => (animal && animal.metricas && animal.metricas.total) ? animal.metricas.total : [])

                metricasTotalesAnimales?.forEach((metrica) => {
                    objMetricasTotales.clics.perfil += metrica.clics.perfil;
                    objMetricasTotales.impresiones.perfil += metrica.impresiones.perfil;
                })

                showMetricas = true
            }

        } catch (e) {
            console.error("Metricas de animales no cargadas", e)
            showMetricas = false
        }

        return (

            <div>
                <Head
                    previousPath={""}
                />
                <div id="page-login" className="page-login main-content">
                    <div className="container">
                        <div className="page-login__wrap">
                            <h2 className="page-login__heading">{infoProtectora.nombre}</h2>
                            <p className="page-login__description">
                                <br/>
                                Desde aquí, puedes modificar tu perfil o administrar los animales que tienes dados de
                                alta en la plataforma
                            </p>
                        </div>
                        {/*{(infoProtectora.metricas) ?*/}
                        {/*    <div className="page-login__wrap">Tienes {infoProtectora.metricas.total.clics.perfil} visitas al*/}
                        {/*        perfil</div>*/}
                        {/*    : <div className="page-login__wrap"/>*/}
                        {/*}*/}
                    </div>
                    <div>
                        <div className="div-metricas-hall">

                            <details>
                                <summary className="titulo-chart">Métricas de tus animales
                                    <div className="listing-houses__item-warning-beta">
                                        {/*<div className="tooltip">*/}
                                        {/*    Beta*/}
                                        {/*    <span className="tooltiptext-left">Las métricas están en fase beta y podrían contener algún error.</span>*/}
                                        {/*</div>*/}
                                    </div>
                                </summary>
                                <p className="subtitulo-chart">Aquí aparece las veces que han sido mostrados tus
                                    animales en el buscador (impresiones) y las veces que alguien a visto su ficha en
                                    detalle (clics) (a traves del buscador o compartiendo el RRSS).
                                    <br/>
                                    Puedes ver las metricas individuales en las tarjetas de cada
                                    animal en la parte de administración</p>
                            </details>

                            {showMetricas &&
                            <div className="div-metricas-totales">
                                <ChartNumberImpresiones impresiones={objMetricasTotales.impresiones.perfil}/>
                                <ChartNumberClics clics={objMetricasTotales.clics.perfil}/>
                                <ChartNumberCTR
                                    impresiones={objMetricasTotales.impresiones.perfil}
                                    clics={objMetricasTotales.clics.perfil}/>
                            </div>
                            }

                            <GraficoLineas multipleData={this.props.animals}/>
                        </div>

                    </div>
                    {/*<button onClick={() => this.goinsertAnimal()} href="#" type="button"*/}
                    {/*        className="btn btn-outline-secondary button-admin-hall" aria-label="Left Align">*/}
                    {/*    <span className="las la-2x la-plus icon-button-admin-hall" aria-hidden="true"/> Añadir nuevo*/}
                    {/*    animal*/}
                    {/*</button>*/}
                    {/*<button onClick={() => this.goAdminAnimals()} href="#" type="button"*/}
                    {/*        className="btn btn-outline-secondary button-admin-hall" aria-label="Left Align">*/}
                    {/*    <span className="las la-2x la-paw icon-button-admin-hall" aria-hidden="true"/> Administrar*/}
                    {/*    animales*/}
                    {/*</button>*/}
                    {/*<button onClick={() => this.goPerfil()} href="#" type="button"*/}
                    {/*        className="btn btn-outline-secondary button-admin-hall" aria-label="Left Align">*/}
                    {/*    <span className="las la-2x la-user icon-button-admin-hall" aria-hidden="true"/> Ir a Perfil*/}
                    {/*</button>*/}
                </div>
                <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
            </div>
        );
    }

    componentWillMount() {
        if (!this.props.access.isLogin) {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
        } else {
            this.props.loadInfoProtectoraDetail(this.props.access.id, this.animalsControl, "completa");
            this.props.getAnimalsProtectora({varsData: {id_protectora: this.props.access.id}});
        }

        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({                scrollTop: element.offset().top            }, 0);
        }

    }

    componentDidMount() {
        // $('.page-login').addClass('animated-400ms fadeIn');
        $('.page-login').show();
        // let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        if (this.props.animals === undefined || this.props.animals.length === 0) {
            this.props.getAnimalsProtectora({varsData: {id_protectora: this.props.access.id}});
        }

        if (!this.props.showHead) {

            // $('.header-topbar').addClass('animated-400ms fadeInDown').one(animationEnd, () => {
            $('.header-topbar').removeClass('animated-400ms fadeInDown');
            // });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            $('.header-topbar').removeClass('animated-400ms fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }


    }

}

function mapStateToProps(state) {
    return {
        access: state.access,
        showHead: state.structureControl.showHead,
        animalDetailProtectora: state.animalDetailProtectora,
        animals: state.animalsProtectora.list
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    isLogin: checkIsLogin,
    loadInfoProtectoraDetail,
    getAnimalsProtectora
})(AdminHallPage)
